import { render, staticRenderFns } from "./TechParamList.vue?vue&type=template&id=57047aab&scoped=true"
import script from "./TechParamList.vue?vue&type=script&lang=js"
export * from "./TechParamList.vue?vue&type=script&lang=js"
import style0 from "./TechParamList.vue?vue&type=style&index=0&id=57047aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57047aab",
  null
  
)

export default component.exports